/**
 * Creates a string that is either lazy (UMD builds) or eager (main app build).
 *
 * - **UMD builds** (vite.configWxCopilot, vite.configWxNavbar): return a lazy proxy so the
 *   getter runs at runtime and can read from window/umd-config (import.meta.env is
 *   replaced with tokens). Defers evaluation until after the UMD entry defines globals.
 * - **Main app build** (vite.config): returns a plain string by calling the getter once.
 */
const isUmdBuild =
  import.meta.env.VITE_WX_COPILOT_UMD_BUILD === 'true' ||
  import.meta.env.VITE_WX_NAVBAR_UMD_BUILD === 'true';

export const createLazyStringIfUmd = (getter: () => string): string => {
  if (isUmdBuild) {
    const obj = Object.create(String.prototype);
    obj[Symbol.toPrimitive] = getter;
    obj.toString = getter;
    obj.valueOf = getter;
    return obj as unknown as string;
  }
  return getter();
};
